import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { McModalComponent, ModalType } from './mc-modal/mc-modal.component';
import { ApiCallComponent } from '../../public/samples/api-call/api-call.component';



@Injectable()
export class ModalService {
  constructor(private dialog: MatDialog) { }
  // activate: (message?: string, title?: string, settings?: { okText?: string, cancelText?: string }) => Observable<boolean>;
  activateError(title?: string, message?: string): Observable<any> {
    return this.activate(title, message, {type: ModalType.ERROR});
  }

  activate(title?: string, message?: string, settings: any = {type: ModalType.MESSAGE}): Observable<any> {
    const config: MatDialogConfig = {
      width: '500px',
      height: '200px',
      panelClass: 'br-dialog'
    };
    const dialogRef = this.dialog.open(McModalComponent, config);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.settings = settings;
    return dialogRef.afterClosed();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/modal/modal.service.ts